import { render, staticRenderFns } from "./ServicePredictForm.vue?vue&type=template&id=0dd16614&scoped=true&"
import script from "./ServicePredictForm.vue?vue&type=script&lang=js&"
export * from "./ServicePredictForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd16614",
  null
  
)

export default component.exports